import React, { useState } from 'react';

import { IChangeEvent } from '@rjsf/core';
import Form from '@rjsf/mui';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';

import { Alert, Button } from '@mui/material';

import { convertCodeToSlug } from '~/services/LoyaltyService';
import { queueLoyaltyEarn } from '~/services/ReportingService';

import ErrorDisplay from '../ErrorDisplay';

const DATES_TYPE_EARN_DATES = 'earn_dates';
const DATES_TYPE_PURCHASE_DATES = 'purchase_dates';

const formSchema = {
  description: 'Please enter a date to export all earnings between the selected date range',
  type: 'object',
  properties: {
    startAt: {
      title: 'Select Start Date',
      type: 'string',
      format: 'date',
    },
    endAt: {
      title: 'Select End Date',
      type: 'string',
      format: 'date',
    },
    code: {
      type: 'string',
      title: 'Partnership',
      default: 'qantas',
      enum: [],
    },
    datesType: {
      type: 'string',
      title: 'Dates type',
      default: DATES_TYPE_EARN_DATES,
      enum: [DATES_TYPE_EARN_DATES, DATES_TYPE_PURCHASE_DATES],
    },
  },
};

const uiSchema = {
  startAt: {
    'ui:widget': 'date',
  },
  endAt: {
    'ui:widget': 'date',
  },
};

export default function ExportLoyaltyEarnForm(props) {
  const [successMessage, setSuccessMessage] = useState(false);
  const [error, setError] = useState(null);

  formSchema.properties.code.enum = [];
  props.partnerships.forEach((partnership) => {
    formSchema.properties.code.enum.push(partnership.code);
  });

  const handleSubmit = (event: IChangeEvent) => {
    queueLoyaltyEarn({
      startAt: event.formData.startAt,
      endAt: event.formData.endAt,
      code: convertCodeToSlug(event.formData.code),
      datesType: event.formData.datesType,
    })
      .then(() => {
        setSuccessMessage(true);
      })
      .catch((err) => {
        setError(err.message);
      });
  };

  return (
    <Form
      schema={formSchema as RJSFSchema}
      uiSchema={uiSchema}
      onSubmit={handleSubmit}
      validator={validator}
      showErrorList={false}
    >
      <Button type="submit" variant="contained">
        Email Loyalty Earn Report
      </Button>

      {error && <ErrorDisplay message={error} />}

      {successMessage && (
        <Alert severity="success">
          <p>Your report is queued for delivery and will be emailed shortly.</p>
        </Alert>
      )}
    </Form>
  );
}
